export default __webpack_public_path__ + "static/6-92b6a545755af165c954d0cfb422d53f.png";